import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Cards from "../components/Cards";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Links from "../components/Links";
import {
  FaSearch,
  FaArrowLeft,
  FaArrowRight,
  FaRegFolder,
} from "react-icons/fa";
import { StyledForm, StyledPaginator, FilterButton } from "./styled";
import Button from "react-bootstrap/Button";
import ReactPaginate from "react-paginate";
import {
  getPage,
  getFilterFlag,
  getFilterClean,
  getChangepage,
} from "../store";
import NoEncontrado from "../components/no-encontrado";

function Home(props) {
  const [contentDataOr, setDataOr] = useState([]);
  const [contentDataBk, setDataBk] = useState([]);
  const [query, setquery] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const ITEMS_PER_PAGE = 8;

  // Reset to page 1 whenever filters or search changes
  useEffect(() => {
    if (props.page !== 1) {
      props.getPage(1);
    }
  }, [appliedFilters, query]);

  useEffect(() => {
    if (!props.loading) {
      setDataOr(props.cards);
      setDataBk(props.cards);
    }
  }, [props.cards, props.loading, props.filter_clean]);

  useEffect(() => {
    const filteredData = contentDataOr.filter((item) => {
      // First apply category filters
      const matchesFilters = appliedFilters.length === 0 || appliedFilters.some((filter) => {
        if (filter === "IA") {
          return item.ia === "1";
        } else {
          return item.categoria === filter;
        }
      });

      // Then apply search query if it exists
      return matchesFilters && (!query || item.descripcion.toLowerCase().includes(query.toLowerCase()));
    });

    setDataBk(filteredData);
  }, [contentDataOr, appliedFilters, query]);

  const handlePageClick = (data) => {
    const { selected } = data;
    props.getPage(selected + 1);
  };

  const handleFilterQuery = (e) => {
    e.preventDefault();
    setquery(e.target.value);
  };

  const handleFilterToggle = (event) => {
    event.preventDefault();
    const filter = event.target.value;
    setAppliedFilters((prevFilters) => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((f) => f !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
  };

  const handleRemoveAllFiltersButoon = (e) => {
    setquery("");
    setAppliedFilters([]);
    props.getPage(1);
    props.getFilterClean();
  };

  const handlePagination = () => {
    const totalPages = Math.ceil(contentDataBk.length / ITEMS_PER_PAGE);
    
    // Don't show pagination if there's only one page or no data
    if (totalPages <= 1) {
      return null;
    }

    // Make sure current page isn't beyond total pages
    const currentPage = Math.min(props.page, totalPages);
    if (props.page !== currentPage) {
      props.getPage(currentPage);
    }

    return (
      <ReactPaginate
        previousLabel={<FaArrowLeft />}
        pageCount={totalPages}
        onPageChange={handlePageClick}
        nextLabel={<FaArrowRight />}
        breakLabel={"..."}
        breakClassName={"break-me"}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        containerClassName={"pagination"}
        activeClassName={"active"}
        forcePage={currentPage - 1}
      />
    );
  };

  // Calculate current page items
  const getCurrentItems = () => {
    const startIndex = (props.page - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return contentDataBk.slice(startIndex, endIndex);
  };

  return (
    <>
      <Container>
        <Row
          style={{
            alignItems: "center",
            flexDirection: "column",
            marginBottom: "35px",
          }}
        >
          <Col lg={8} style={{ padding: "0px 32px", marginTop: "35px" }}>
            <StyledForm>
              <Form.Group as={Row} controlId="formPlaintextEmail">
                <Form.Label column md={3} lg={3} className="labeltext">
                  <FaSearch size={25} /> Buscador
                </Form.Label>
                <Col md={9} lg={9} className="inputsearch">
                  <Form.Control
                    type="text"
                    placeholder="Ingresá los términos a buscar"
                    onChange={handleFilterQuery}
                    value={query}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="formPlaintextEmail">
                <Form.Label column md={3} lg={3} className="labeltext">
                  <FaRegFolder size={25} /> Categorias
                </Form.Label>
                <Col md={9} lg={9}>
                  <Row>
                    <Col lg={12} className="inputsearch">
                      <FilterButton
                        value="Imagen"
                        onClick={handleFilterToggle}
                        className={appliedFilters.includes("Imagen") ? "active" : ""}
                      >
                        Imagen
                      </FilterButton>
                      <FilterButton
                        value="Audio"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Audio") ? "active" : ""
                        }
                      >
                        Audio
                      </FilterButton>
                      <FilterButton
                        value="Video"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Video") ? "active" : ""
                        }
                      >
                        Video
                      </FilterButton>
                      <FilterButton
                        value="Diseño"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Diseño") ? "active" : ""
                        }
                      >
                        Diseño
                      </FilterButton>
                      <FilterButton
                        value="IA"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("IA") ? "active" : ""
                        }
                      >
                        IA
                      </FilterButton>
                      <FilterButton
                        value="Otras"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Otras") ? "active" : ""
                        }
                      >
                        Otras
                      </FilterButton>
                      <FilterButton
                        value="Chequeado"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Chequeado") ? "active" : ""
                        }
                      >
                        Chequeado
                      </FilterButton>
                      <FilterButton
                        value="Datos"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Datos") ? "active" : ""
                        }
                      >
                        Datos
                      </FilterButton>
                      <FilterButton
                        value="Factchecking"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Factchecking")
                            ? "active"
                            : ""
                        }
                      >
                        Fact checking
                      </FilterButton>
                      <FilterButton
                        value="Producto"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Producto") ? "active" : ""
                        }
                      >
                        Producto
                      </FilterButton>
                      <FilterButton
                        value="Sitios útiles"
                        onClick={handleFilterToggle}
                        className={
                          appliedFilters.includes("Sitios útiles")
                            ? "active"
                            : ""
                        }
                      >
                        Sitios útiles
                      </FilterButton>
                      </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <Button
                        className="clean"
                        onClick={handleRemoveAllFiltersButoon}
                      >
                        Restablecer filtros
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Form.Group>
            </StyledForm>
          </Col>
        </Row>
        <Row>
          {contentDataBk.length <= 0 ? (
            <NoEncontrado />
          ) : (
            getCurrentItems().map((el, index) => (
              <Col lg={3} key={el.ID || index}>
                <Cards
                  url={el.url}
                  nombre={el.nombre}
                  verificado={el.verificado}
                  ID={el.ID}
                  categoria={el.categoria}
                  descripcion={el.descripcion}
                  favicon_url={el.favicon_url}
                />
              </Col>
            ))
          )}
        </Row>
        <Row>
          <StyledPaginator lg={12}>{handlePagination()}</StyledPaginator>
        </Row>
      </Container>
      <Links />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    cards: state.cards,
    page: state.page,
    loading_filter: state.loading_filter,
    filter_clean: state.filter_clean,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPage: (page) => dispatch(getPage(page)),
    getFilterFlag: () => dispatch(getFilterFlag()),
    getFilterClean: () => dispatch(getFilterClean()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);